import React from 'react'
import Address from '../../../../specific/components/footers/PageFooter/Address'
import Columns from './Columns'
import LogoList from './LogoList'
import Miscellaneous from '../../../../specific/components/footers/PageFooter/Miscellaneous'
import styles from './pageFooter.module.scss'

export default function PageFooter() {
  return (
    <div className={styles.main_footer_container}>
      <LogoList />
      <Columns />
      <Miscellaneous />
      <Address />
    </div>
  )
}
